import { EmailSubscription } from "@/domain/emailSubscription/emailSubscription";
import { httpClient } from "./http-client";
const basePath = "/email-subscription";

export const emailSubscriptionAPI = {
  create: async (emailAddress: string, categoryNames: string[], companyName: string, minSalary: string, 
    location: string, attendanceRequirement: string, frequency: string, searchTerm: string , contractType: string) => 
  {
    const url = basePath + "/create";
    return await httpClient.post(url, {
      Emailaddress: emailAddress,
      SearchSubscription : {
        CategoryNames: categoryNames,
        CompanyName: companyName,
        MinSalary: minSalary,
        Location: location,
        AttendanceRequirement: attendanceRequirement,
        SearchTerm: searchTerm,
        ContractType: contractType
      },
      Frequency : frequency
    });
  },
  remove: async (identifier: string) => 
  {
    const url = basePath + "/remove";
    return await httpClient.post(url, {
      Identifier: identifier,
    });
  },
  setActiveStatus: async (identifier: string) => 
  {
    const url = basePath + "/setactivestatus";
    return await httpClient.post(url, {
      Identifier: identifier,
    });
  },
  redeem: async (identifier: string) => 
  {
    const url = basePath + "/redeem";
    return await httpClient.post(url, {
      Identifier: identifier,
    });
  },
  get: async (groupidentifier: string) => 
  {
    const url = basePath + "/getbygroupedidentifer?groupidentifier=" + groupidentifier;
    const response = await httpClient.get(url);
    return response.data as EmailSubscription;
  },
};